/**
 * 获取业务环境中文名称
 */
export function getEvnZHName(type) {
    let name = ''
    switch (type) {
        case 'dev':
            name = '开发'
            break
        case 'test':
            name = '测试'
            break
        case 'beta':
            name = '预发布'
            break
        case 'prod':
            name = '生产'
            break
        default:
            break
    }
    return `${name}环境`
}

export default {
    getEvnZHName,
}
